"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchStreamId = void 0;
const typings_1 = require("@arcxgame/contracts/dist/src/typings");
function fetchStreamId(signer, creditScoreContractAddress) {
    return __awaiter(this, void 0, void 0, function* () {
        const creditScoreContract = typings_1.SapphirePassportScoresFactory.connect(creditScoreContractAddress, signer);
        const ceramicStreamId = yield creditScoreContract.documentId();
        if (!ceramicStreamId) {
            throw Error(`The credit score contract at ${creditScoreContractAddress} returned no ceramic document ID`);
        }
        return ceramicStreamId;
    });
}
exports.fetchStreamId = fetchStreamId;
//# sourceMappingURL=fetchStreamId.js.map